module.exports = __webpack_public_path__ + "img/kagami-white.cc7623ae.png";